import BusDetails from './BusDetails';

export default BusDetails;
